<script setup lang="ts">
import { type PropType, toRef } from 'vue';

const props = defineProps({
  parcel: {
    type: Object as PropType<any>,
    required: true
  },
  moduleClassName: {
    type: String as PropType<string>,
    required: false
  }
});

const parcelItem = toRef(props.parcel);
</script>

<template>
  <v-card
    variant="elevated"
    :class="`${moduleClassName}-wizard-parcel-card`">
    <template #prepend>
      <div :class="`${moduleClassName}-wizard-parcel-card__icon`">
        <div
          v-if="parcel.svg"
          class="d-flex align-center justify-center w-100 h-100"
          v-html="parcel.svg" />
        <v-icon
          v-else
          style="opacity: 0.3"
          icon="mdi-image-off-outline"
          size="6rem"
          color="grey-lighten-1" />
        <v-icon
          class="position-absolute"
          style="filter: drop-shadow(0 0 8px white)"
          size="3rem" />
      </div>
    </template>
    <template #title>
      <div :class="`${moduleClassName}-wizard-parcel-card__title`">
        <span>{{ parcelItem.name }}</span>
        <span class="text-grey ml-3 font-weight-light">{{ parcelItem.area }} ha</span>
      </div>
    </template>
    <template #item>
      <slot name="item" />
    </template>
  </v-card>
</template>
